
import MainLayout from "@/components/layout/MainLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SearchDatePicker } from "@/components/common/SearchDatePicker";
import { useState } from "react";
import { Train } from "lucide-react";

const Railways = () => {
  const [fromStation, setFromStation] = useState("");
  const [toStation, setToStation] = useState("");
  const [date, setDate] = useState<Date | undefined>();

  const handleSearch = () => {
    // In a full implementation, this would call the Indian Railways API
    console.log("Search trains:", {
      fromStation,
      toStation,
      date
    });
    
    // For now, we'll display some placeholder text
    alert("Train search functionality will be implemented when connected to Supabase.");
  };

  return (
    <MainLayout>
      <div className="travel-container py-12">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">Indian Railways Search</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Find train routes, schedules, and availability across India.
          </p>
        </div>
        
        <div className="search-card max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <Input
                placeholder="From Station"
                value={fromStation}
                onChange={(e) => setFromStation(e.target.value)}
              />
            </div>
            <div>
              <Input
                placeholder="To Station"
                value={toStation}
                onChange={(e) => setToStation(e.target.value)}
              />
            </div>
          </div>
          
          <div className="mb-6">
            <SearchDatePicker
              date={date}
              onSelect={setDate}
              label="Journey Date"
              minDate={new Date()}
            />
          </div>
          
          <Button 
            className="w-full bg-travel-blue hover:bg-blue-700"
            onClick={handleSearch}
          >
            <Train className="mr-2 h-4 w-4" />
            Search Trains
          </Button>
        </div>
        
        <div className="mt-8 max-w-3xl mx-auto">
          <h3 className="font-medium text-xl mb-4">Popular Routes</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { from: "Delhi", to: "Mumbai" },
              { from: "Bangalore", to: "Chennai" },
              { from: "Kolkata", to: "Delhi" },
              { from: "Mumbai", to: "Goa" },
              { from: "Chennai", to: "Hyderabad" },
              { from: "Delhi", to: "Jaipur" }
            ].map((route, index) => (
              <div 
                key={index} 
                className="bg-white p-4 rounded-lg shadow-sm border hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => {
                  setFromStation(route.from);
                  setToStation(route.to);
                }}
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="font-medium">{route.from}</div>
                  <div className="text-travel-blue">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="font-medium">{route.to}</div>
                </div>
                <div className="text-sm text-gray-500">Popular route</div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center text-gray-500">
          <p>
            Note: Full train search capabilities will be enabled when connected to Supabase.
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default Railways;
